export function getTimeString(milliseconds, shortFormat) {
    const seconds = Math.floor(milliseconds / 1000);
    const minutes = Math.floor(seconds / 60) % 60;
    const hours = Math.floor(seconds / (60 * 60));
    if (shortFormat) {
        const minuteString = minutes === 0 ? '' : `${minutes}m`;
        const hoursString = hours === 0 ? '' : `${hours}h`;
        const result = [hoursString, minuteString].join(' ');
        return hoursString || minuteString ? result : '0h';
    }
    return `${hours} ${hours > 1 || hours === 0 ? 'hours' : 'hour'} ${minutes} minutes`;
}
